import React, { FC } from 'react'

import { Col, Row } from 'antd'

import { Route } from 'react-router-dom'
import ProjectGallery from 'pages/dashboard/projects'
import PluginGallery from 'pages/dashboard/plugins'
import RecipeGallery from 'pages/dashboard/recipes'

import { UserDashboard } from 'organisms'

export const Dashboard: FC<any> = () => {
  return (
    <Row gutter={[8, 8]} justify={'center'}>
      <Col 
        xxl={14} xl={16} lg={18} md={20} sm={24} xs={24}>
        <Route exact path="/" component={UserDashboard} />
        <Route exact path="/projects" component={ProjectGallery} />
        <Route exact path="/recipes" component={RecipeGallery} />
        <Route exact path="/plugins" component={PluginGallery} />
      </Col>
    </Row>
  )
}